/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { routerActions } from 'react-router-redux';
import { injectIntl } from 'react-intl';
import {
  Grid,
  Row,
  Col,
  Panel,
  Table,
} from 'react-bootstrap';
import format from 'date-fns/format';
import Toolbar from 'loracoms/Toolbar';
import RichLabel from 'loracoms/RichLabel';
import Nvl from 'loracoms/Nvl';
import deviceActions from 'loraactions/device';
import IntlMsg from 'lorautils/intl/IntlMsg';
import { normalizeMac, normalizeDevEUI } from 'lorautils/IdUtils';
import callAPI from '@/api/callAPI';
import DefLink from './coms/DefLink';
import styles from './styles.scss';

const propTypes = {
  intl: PropTypes.any.isRequired,
  deviceId: PropTypes.string.isRequired,
  links: PropTypes.object.isRequired,
  deviceState: PropTypes.object.isRequired,
  getLinks: PropTypes.func.isRequired,
  pushState: PropTypes.func.isRequired,
  appId: PropTypes.string.isRequired,
  appState: PropTypes.object.isRequired,
  replaceState: PropTypes.func.isRequired,
};

class TopoView extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      deviceState: props.deviceState,
      appState: props.appState,
      links: props.links,
    };
    this.intlMsg = new IntlMsg(props.intl, 'devicedetail.topoview');
  }

  componentWillMount() {
    const { deviceId, getLinks } = this.props;
    getLinks(deviceId);
  }

  componentWillReceiveProps(nextProps) {
    const { deviceState, appState, links } = nextProps;
    if (links !== this.props.links) {
      this.setState({ links });
    }
    if (deviceState !== this.props.deviceState) {
      this.setState({ deviceState });
    }
    if (appState !== this.props.appState) {
      this.setState({ appState });
    }
  }

  handleOnDelete(gateway) {
    const { deviceId, getLinks } = this.props;
    callAPI({
      endpoint: `/lora/nodes/${deviceId}/links/${gateway}`,
      method: 'DELETE',
    }).then(() => {
      getLinks(deviceId);
    }).catch(() => {});
  }

  renderToolbar() {
    const { pushState, appId, deviceId, replaceState } = this.props;
    const {
      deviceState: {
        data: { name } = {},
        status,
      },
      appState: {
        data: { name: appName } = {},
        status: appStatus,
      },
    } = this.state;
    const breadcrumb = [{
      content: this.intlMsg.msg('breadcrumb.application', 'application'),
      onClick: () => pushState('/application'),
    }, {
      content: <Nvl val={appName} status={appStatus} />,
      onClick: () => replaceState(`/application/${appId}`),
    }, {
      content: <Nvl val={name || normalizeDevEUI(deviceId)} status={status} />,
      active: true,
    }];
    return <Toolbar breadcrumb={breadcrumb} />;
  }

  renderContent() {
    const { pushState } = this.props;
    const { links: { data: { links = [], best = '' } = {} } = {} } = this.state;
    const list = links || [];

    const rows = list.map(l => (
      <tr key={l.gateway}>
        <td>
          <Link onClick={() => pushState(`/gateway/detail/${l.gateway}`)}>
            {normalizeMac(l.gateway)}
          </Link>
          {best === l.gateway && (
            <span className={styles.best}>
              {this.intlMsg.msg('best')}{' '}
              <span className="halflings halflings-thumbs-up" />
            </span>
          )}
        </td>
        <td>{format(l.time, 'YYYY-MM-DD HH:mm:ss')}</td>
        <td>{l.rssi}</td>
        <td>{l.snr.toFixed(2)}</td>
        <td>{l.fcnt}</td>
        <td><RichLabel content={l.dr.modulation} /></td>
        <td>{l.dr.spreadFactor}</td>
        <td>{l.dr.bandwidth}</td>
        <td>{l.dr.bitrate}</td>
        <td>
          <Link
            className={styles.delete}
            onClick={() => this.handleOnDelete(l.gateway)}
          >
            <span className="halflings halflings-trash" />
          </Link>
        </td>
      </tr>
    ));

    return (
      <Panel bsStyle="aisz-white" header={this.intlMsg.msg('header')}>
        <Table className="aisz-table-light" striped hover bordered responsive>
          <thead>
            <tr>
              <th rowSpan={2}>{this.intlMsg.msg('data.gateway')}</th>
              <th rowSpan={2}>{this.intlMsg.msg('data.time')}</th>
              <th rowSpan={2}>RSSI</th>
              <th rowSpan={2}>SNR</th>
              <th rowSpan={2}>{this.intlMsg.msg('data.fcnt')}</th>
              <th colSpan={4} className="text-center">{this.intlMsg.msg('data.dr')}</th>
              <th rowSpan={2}>{this.intlMsg.msg('data.delete')}</th>
            </tr>
            <tr>
              <th>{this.intlMsg.msg('data.modulation')}</th>
              <th>{this.intlMsg.msg('data.sf')}</th>
              <th>{this.intlMsg.msg('data.bandwidth')}</th>
              <th>{this.intlMsg.msg('data.bitrate')}</th>
            </tr>
          </thead>
          <tbody>
            {rows}
          </tbody>
        </Table>
      </Panel>
    );
  }

  render() {
    return (
      <Grid fluid>
        <Row>
          <Col md={12}>
            {this.renderToolbar()}
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <DefLink deviceId={this.props.deviceId} />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            {this.renderContent()}
          </Col>
        </Row>
      </Grid>
    );
  }
}


TopoView.propTypes = propTypes;

const mapStateToProps = (state, ownProps) => ({
  deviceState: state.device.getDevice || {},
  appState: state.app.getApp || {},
  links: state.device.getLinks || {},
  deviceId: ownProps.params.deviceId,
  appId: ownProps.params.appId,
});

const mapDispatchToProps = {
  getLinks: deviceActions.getLinks,
  pushState: routerActions.push,
  replaceState: routerActions.replace,
};

export default connect(mapStateToProps, mapDispatchToProps)(
  injectIntl(TopoView));




// WEBPACK FOOTER //
// ./src/containers/Application/coms/DeviceDetail/coms/TopoView/index.jsx